import apiClient from "../clinet";

// Get all posts media
const getPostsMedia = async () => {
  const response = await apiClient.get("/posts/media");
  return response.data;
};

// Get posts media by post ID
const getPostsMediaByPostId = async (postId: string | number) => {
  const response = await apiClient.get(`/posts-media/post/${postId}`);
  return response.data;
};

// Create new post media
const createPostMedia = async (mediaData: any) => {
  const response = await apiClient.post("/posts-media", mediaData);
  return response.data;
};

// Update post media
const updatePostMedia = async ({
  id,
  data,
}: {
  id: string | number;
  data: any;
}) => {
  const response = await apiClient.put(`/posts-media/${id}`, data);
  return response.data;
};

// Delete post media
const deletePostMedia = async (id: string | number) => {
  const response = await apiClient.delete(`/posts-media/${id}`);
  return response.data;
};

export default {
  getPostsMedia,
  getPostsMediaByPostId,
  createPostMedia,
  updatePostMedia,
  deletePostMedia,
};
